<template>
  <div class="intro">
    <SideMenu></SideMenu>
        <p>This is the other part of These Pages Fall Like Ash. </p>

        <p>The physical book is your guide to the space around you, so keep it with you; it contains a voice from another place.</p>

        <p>We will ask you to walk during this story. </p>

        <p>Walk, and imagine. {{ this.$route.params.email }}</p>

    <NavButton dest="Login"/>
    <NavButton dest="Contents"/>
    <button class="button" v-on:click="getPermission()">Get permission</button>
    <button class="button" v-on:click="sendNotif()">Notify</button>
    <button class="button" v-on:click="alertify()">Alertify</button>
  </div>
</template>
<script>
export default {
  name: 'Intro',
  components: {
  },
  props: {
    email: String
  },
  data () {
    return {
      email2: this.$route.params.email
    }
  },
  methods: {
    getPermission () {
      // Request Permission of Notifications
      Notification.requestPermission().then(() => {
        console.log(Notification.permission)
      }).catch((err) => {
        console.log('Unable to get permission to notify.', err)
      })
    },
    sendNotif () {
      setTimeout(function () {
        navigator.serviceWorker.getRegistration()
          .then((reg) => reg.showNotification('These Pages Fall Like Ash', {
            body: 'Hello World',
            vibrate: [400, 100, 200],
            data: {
              url: window.location.href // pass the current url to the notification
            },
            actions: [
              {
                action: 'open',
                title: 'Open app'
              },
              {
                action: 'close',
                title: 'Close notification'
              }
            ],
            badge: './img/ionic.png',
            icon: './img/ionic.png'
          }))
      }, 3000)
    },
    alertify () {
      this.$alertify.confirm('new alert!', () => {
        console.log(this.$alertify.elements)
      })
    }
  }
}
</script>
